import _ from 'lodash';
import classNames from 'classnames';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/clubActions';
import { Link, withRouter } from 'react-router';
import HeaderImage from '../../components/common/HeaderImage';
import TextInput from '../../components/common/TextInput';
import Button from '../../components/common/Button';
import toastr from 'toastr';

class ManageClubPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.shouldUpdateClubDetails = this.shouldUpdateClubDetails.bind(this);
    this.updateClubForm = this.updateClubForm.bind(this);
    this.askBeforeExit = this.askBeforeExit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.imageFieldChange = this.imageFieldChange.bind(this);
    let clubDetails = {description: ''};
    let errors = {};
    if (props.clubId) {
      clubDetails = objectAssign({}, props.clubDetails);
    }
    this.state = {
      clubDetails: clubDetails,
      loadingClubs: false,
      errors: errors,
    };
  }

  componentWillMount() {
    this.props.router.setRouteLeaveHook(this.props.route, () => {
      return this.askBeforeExit();
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.clubId && this.props.clubId != this.props.clubDetails.id) {
      this.setState({
        clubDetails: {},
        errors: {},
      });
    }
    if(this.shouldUpdateClubDetails(nextProps)) {
      this.setState({
        clubDetails: nextProps.clubDetails,
        errors: {},
        loadingClubs: nextProps.loadingClubs,
      });
    } else if(!_.isEqual(this.props.errors, nextProps.errors)) {
      this.setState({
        loadingClubs: false,
        errors: nextProps.errors,
      });
    }
  }

  shouldUpdateClubDetails(nextProps) {
    let p = this.props;
    let updated = p.clubDetailsUpdated !== nextProps.clubDetailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  updateClubForm(e) {
    let clubDetails = objectAssign({}, this.state.clubDetails);
    clubDetails[e.target.name] = e.target.value;
    return this.setState({
      clubDetails: clubDetails
    });
  }

  uploadImage(e) {
    e.preventDefault();
    this.setState({
      loadingClubs: true,
    });
    toastr.info('Lagrer bilde');
    if (this.props.clubId) {
      this.props.actions.updateClubImage(this.props.clubId, this.state.clubDetails['image_upload']);
    }
  }

  imageFieldChange(event) {
    let clubDetails = objectAssign({}, this.state.clubDetails);
    clubDetails['image'] = URL.createObjectURL(event.target.files[0]);
    clubDetails['image_upload'] = event.target.files[0];
    this.setState({
      clubDetails: clubDetails
    });
  }

  submitForm() {
    toastr.info('Lagrer');
    if (this.props.clubId) {
      this.props.actions.updateClub(this.state.clubDetails);
    } else {
      this.props.actions.createClub(this.state.clubDetails);
    }
    this.setState({
      loadingClubs: true,
    });
  }

  askBeforeExit() {
    let changed = this.props.clubId && !_.isEqual(this.props.clubDetails, this.state.clubDetails);
    if (this.props.clubId && changed && !confirm('Ønsker du å gå tilbake uten å lagre?')) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    let details = this.state.clubDetails;
    return (
      <div className="manage-club-page-container container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div className="panel panel-default">
              <div className="image-upload-wrapper">
                <form onSubmit={this.uploadImage}>
                  {details.id && <label htmlFor="upload-image" className="select-image-label">
                    <HeaderImage
                      headerLink={details.image}/>
                  </label>}
                  {!details.id && <HeaderImage
                    headerLink={details.image}/>}
                  <div className={classNames('form-group image-upload', {
                      hidden: !details.id
                    })}>
                      <div className="col-sm-8">
                        <input
                          type="file" id="upload-image"
                          onChange={this.imageFieldChange}
                          className="form-control"
                          accept=".png,.jpg,.jpeg"
                          />
                      </div>
                      <div className="col-sm-4">
                        <input
                          type="submit"
                          value="Las opp"
                          disabled={this.state.loadingClubs}
                          className="btn btn-primary btn-block"/>
                      </div>
                  </div>
                </form>
              </div>
              <div className="panel-body">
                <TextInput
                  name="name"
                  error={this.state.errors.name}
                  inputClass="input-lg"
                  placeholder="Klubbnavn"
                  onChange={this.updateClubForm}
                  value={details.name}
                  />
                <hr/>
                <h3 className="page-header">
                  Kontaktperson
                </h3>
                <TextInput
                  label="Fullt navn"
                  error={this.state.errors.club_contact_person}
                  name="club_contact_person"
                  onChange={this.updateClubForm}
                  value={details.club_contact_person}
                  />
                <TextInput
                  label="Telefonnummer"
                  name="club_contact_phone_number"
                  error={this.state.errors.club_contact_phone_number}
                  onChange={this.updateClubForm}
                  value={details.club_contact_phone_number}
                  />
                <TextInput
                  label="Epost"
                  name="club_contact_email"
                  error={this.state.errors.club_contact_email}
                  onChange={this.updateClubForm}
                  value={details.club_contact_email}
                  />
                <h3 className="page-header">
                  Klubbinformasjon
                </h3>
                <TextInput
                  label="Adresse"
                  name="club_address"
                  error={this.state.errors.club_address}
                  onChange={this.updateClubForm}
                  value={details.club_address}
                  />
                <div className="row">
                  <div className="col-sm-3">
                    <TextInput
                      label="Postnummer"
                      name="club_zip"
                      error={this.state.errors.club_zip}
                      onChange={this.updateClubForm}
                      value={details.club_zip}
                      />
                  </div>
                  <div className="col-sm-3">
                    <TextInput
                      label="Kommune"
                      name="club_municipality"
                      error={this.state.errors.club_municipality}
                      onChange={this.updateClubForm}
                      value={details.club_municipality}
                      />
                  </div>
                  <div className="col-sm-3">
                    <TextInput
                      label="Fylke"
                      name="club_county"
                      error={this.state.errors.club_county}
                      onChange={this.updateClubForm}
                      value={details.club_county}
                      />
                  </div>
                  <div className="col-sm-3">
                    <TextInput
                      label="Land"
                      name="club_country"
                      error={this.state.errors.club_country}
                      onChange={this.updateClubForm}
                      value={details.club_country}
                      />
                  </div>
                </div>

              </div>
              <div className="panel-footer clearfix">
                <Button
                  permission={this.props.clubDetails.permissions.write}
                  className="btn btn-primary pull-right"
                  disabled={this.state.loadingClubs}
                  faName={'save'}
                  onClick={this.submitForm}>
                    {' Lagre'}
                </Button>
                <Link className="btn btn-default"
                  to={'/klubb' + (details.id ? ('/' + details.id) : 'er')}>
                  Tilbake
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManageClubPage.propTypes = {
  actions: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  route: PropTypes.object,
  errors: PropTypes.object,
  clubDetailsUpdated: PropTypes.number.isRequired,
  clubId: PropTypes.string,
  loadingClubs: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    loadingClubs: state.clubs.loadingClubs,
    clubDetails: state.clubs.clubDetails,
    errors: state.clubs.errors,
    clubDetailsUpdated: state.clubs.clubDetailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageClubPage));



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/ManageClubPage.js
 **/